module.exports = __webpack_public_path__ + "static/media/Inconsolata-VariableFont_wdth,wght.3701d12f.ttf";